module.exports = __webpack_public_path__ + "img/p&s-course4.a94645b6.jpg";